<div class="hours-wrapper" [ngClass]="periodType[hours.type] | lowercase" *ngFor="let hours of hourPrices; let i = index">
  <div
    class="hour"
    [class.active]="allActive || isActiveClass(j, hours)"
    *ngFor="let hour of getHoursArray(hours.from, hours.to); let j = index"
  ></div>
</div>
